import React from 'react'

const DynamicLinkQRcode = ({ qrCodeImageURL }) => (
  <div className="card-image">
    <figure className="image is-1by1">
      <img src={qrCodeImageURL} alt="qrcode"/>
    </figure>
  </div>
)

// const Image = styled.img`
//   height: 20em;
//   width: 20em;
// `

export default DynamicLinkQRcode;


// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkQRcode.js